// extracted by mini-css-extract-plugin
export default {"fade":"Pl8iO","fadeIn":"N70gG"};